import {motion} from 'framer-motion'
import {Box, CSSProperties} from 'jsxstyle'

import {useDialogContext} from './DialogContext'
import {PropsWithChildren} from 'react'

type DialogContentProps = CSSProperties & {
  animated?: boolean
  props?: JSX.IntrinsicElements['div']
}

const DialogContent: React.FC<PropsWithChildren<DialogContentProps>> = ({children, props, ...css}) => {
  const animated = true
  const {refs, getFloatingProps} = useDialogContext()

  return (
    <Box
      component={motion.div}
      background="white"
      borderRadius="8px"
      boxShadow="0 0 20px 20px rgba(0, 0, 0, 0.1)"
      minHeight="0"
      minWidth="0"
      maxHeight="100%"
      maxWidth="100%"
      width="100%"
      display="flex"
      boxSizing="border-box"
      {...css}
      props={{
        ...(animated && {
          initial: {opacity: 0, scale: 0.9},
          animate: {opacity: 1, scale: 1},
          exit: {opacity: 0, scale: 0.9},
          transition: {duration: 0.2},
        }),
        ref: refs.setFloating,
        ...getFloatingProps(props),
        onMouseDown: (e) => e.stopPropagation(),
        onClick: (e) => {
          e.preventDefault()
          e.stopPropagation()
          e.preventDefault()
        },
      }}
    >
      {children}
    </Box>
  )
}

export default DialogContent
